/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-mate.agent-header-banner-label': 'エージェント バナー',
  'ai-mate.agent-list.all-agents-section-title': 'すべてのエージェント',
  'ai-mate.agent-list.beta-lozenge-title': 'ベータ版',
  'ai-mate.agent-list.change-owner-success-flag-description':
    '{agentName} の所有者を {newOwnerName} さんに変更しました',
  'ai-mate.agent-list.change-owner-success-flag-title': '所有者は正常に変更されました',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'このエージェントを削除してもよろしいですか? この操作は元に戻せません。',
  'ai-mate.agent-list.delete-agent-confirm-title': '"{agentName}" を削除しますか?',
  'ai-mate.agent-list.delete-agent-error': 'エージェントを削除できませんでした',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'エージェントの削除中に問題が発生しました。しばらくしてからもう一度お試しください。',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'エージェントを削除できませんでした',
  'ai-mate.agent-list.delete-agent-error.agent-in-use':
    'エージェントは現在使用中です。しばらくしてからもう一度お試しください。',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': '指定したエージェントが見つかりませんでした。',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'あなた自身が作成していないエージェントは削除できません。エージェントの所有者にお問い合わせください。',
  'ai-mate.agent-list.delete-agent-success-flag-description': '{agentName} を削除しました',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'エージェントが削除されました',
  'ai-mate.agent-list.development-section-title': '開発エージェント',
  'ai-mate.agent-list.recommended-agents-section-title': 'お勧め',
  'ai-mate.agent-list.templates-description':
    '独自の開発エージェントを作成するためのテンプレートです。業務に適したエージェント テンプレートを選んで [テンプレートを使用] を選択したら、テンプレート プロンプトにリポジトリ、フォルダー、言語、ライブラリなどの詳細を具体的に入力します。さまざまなタスク、プロジェクト、リポジトリをコーディングするためのカスタマイズされた開発エージェントを作成できます。',
  'ai-mate.agent-list.templates-lozenge-title': 'テンプレート',
  'ai-mate.agent-list.templates-title': 'コーディング テンプレート',
  'ai-mate.agent-message.agent-not-found': 'エージェントが見つかりません',
  'ai-mate.agent-message.convo-title': 'スマート リンク埋め込みから {agentName} とのチャットがトリガーされました',
  'ai-mate.agent-message.copy-link': 'エージェント リンクをコピー',
  'ai-mate.agent-message.prompt': 'プロンプト',
  'ai-mate.agent-message.prompt-placeholder': '{agentName} へのメッセージを入力',
  'ai-mate.agent-message.prompt-submit': '送信',
  'ai-mate.agent-message.view-profile': 'プロファイルを表示',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'キャンセル',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': '削除',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'エージェント · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': '{agentName} とチャット',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL をコピーしました',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'リンクをコピー',
  'ai-mate.agent-profile-info.hidden-icon': '非表示',
  'ai-mate.agent-profile-info.hidden-tooltip': 'エージェントは検索結果に表示されません',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'エージェントにスターを付ける',
  'ai-mate.agent-selector.default-agent-description':
    '答えを見つけたり、新しいアイデアを生み出したり、日々の仕事を効率化したりできます。',
  'ai-mate.agent-selector.default-agent-name': 'チャット',
  'ai-mate.browse-agents-view.close-button': 'エージェント ビューを閉じる',
  'ai-mate.profile-card-preview.actions-title': 'アクション',
  'ai-mate.profile-card-preview.agent-default-title': 'エージェント',
  'ai-mate.profile-card-preview.agent-description-label': '説明',
  'ai-mate.profile-card-preview.agent-title-label': 'タイトル',
  'ai-mate.profile-card-preview.conversation-starters-heading': '会話のきっかけ',
  'ai-mate.profile-card-preview.empty-actions': 'なし',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'なし',
  'ai-mate.profile-card-preview.empty-instructions': 'なし',
  'ai-mate.profile-card-preview.empty-knowledge-scope': '何も選択されていません',
  'ai-mate.profile-card-preview.instructions-title': '説明',
  'ai-mate.profile-card-preview.knowledge-title': 'ナレッジ',
  'ai-mate.profile-card-preview.regenerate-label': '{fieldName} を再生成',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - コピー',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'ドラッグして並べ替え',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': '変更を保存できませんでした',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    '不明なエラーが発生しました。もう一度お試しください。',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'この名前のエージェントはすでに存在します',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': '削除',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': '会話のきっかけを生成',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, other {{fieldName} は {maxLength,number} 文字以内で入力してください}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': '次へ',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': '再起動',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'スキップして手動セットアップに移動',
  'create-agent.owner-field.confirm-modal-cancel': 'キャンセル',
  'create-agent.owner-field.confirm-modal-confirm': 'はい、続行します',
  'create-agent.owner-field.confirm-modal-content':
    'このエージェントの所有者を {name} さんに変更しようとしています。この操作を行うと、あなたはこのエージェントを編集および管理できなくなります。',
  'create-agent.owner-field.confirm-modal-title': '編集アクセス権が失われます',
  'create-agent.owner-field.owner-description': 'エージェントを編集・管理できるユーザーです。',
  'create-agent.owner-field.owner-label': '所有者',
  'rovo-chat.agent-card.deactivated-name': '{name} (無効化済み)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'リクエストが多すぎます。しばらくお待ちください。',
  'rovo-chat.browse-agents.agents-error-try-again-button': '再試行',
  'rovo-chat.browse-agents.all-agents-button': 'すべて',
  'rovo-chat.browse-agents.close-button': '閉じる',
  'rovo-chat.browse-agents.create-agent-button': '作成',
  'rovo-chat.browse-agents.create-an-agent-button': 'エージェントを作成',
  'rovo-chat.browse-agents.created-by-label': '<text>作成者</text>: {creatorName}',
  'rovo-chat.browse-agents.development-button': 'コーディング エージェント',
  'rovo-chat.browse-agents.favorite-agents-button': 'お気に入り',
  'rovo-chat.browse-agents.favourited-agent-label': 'お気に入りに追加されたエージェント',
  'rovo-chat.browse-agents.modal-title': 'エージェントを参照',
  'rovo-chat.browse-agents.my-agents-button': '私のエージェント',
  'rovo-chat.browse-agents.no-created-agents':
    'まだエージェントを作成していないようです。他の既存のエージェントを複製するか、新しいエージェントを作成することから始めてください。',
  'rovo-chat.browse-agents.no-created-agents-header': 'エージェントはまだ作成されていません',
  'rovo-chat.browse-agents.no-starred-agents':
    'お気に入りのエージェントやよく使用するエージェントがある場合は、簡単にアクセスできるようにスターを付けましょう。',
  'rovo-chat.browse-agents.no-starred-agents-header': 'まだエージェントにスターを付けていません',
  'rovo-chat.browse-agents.search-input.placeholder': 'エージェントを検索',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'テンプレートを検索',
  'rovo-chat.browse-agents.see-all-agents-button': 'すべてのエージェントを表示',
  'rovo-chat.browse-agents.templates-button': 'テンプレート',
  'rovo-chat.create-agent.actions-section-description':
    'エージェントにアクションを追加して、Jira、Confluence、Jira Service Management でタスクを実行します。<link>エージェントのアクションに関する詳細をご確認ください。</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'アクションを追加する',
  'rovo-chat.create-agent.all-content-label': 'すべてのコンテンツ',
  'rovo-chat.create-agent.back-button': '戻る',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'エージェントはまだ作成されていません。破棄してもよろしいですか?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'キャンセル',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'はい、エージェントを破棄します',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'エージェントの作成は未完了です',
  'rovo-chat.create-agent.confirm-restart-modal.body': 'このエージェントに加えた変更を破棄してもよろしいですか?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': '確定',
  'rovo-chat.create-agent.confirm-restart-modal.title': '作成をリスタートする',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'ユーザーはこれらを使用してエージェントとのチャットを開始できます。話すことを思いつかない場合は、アトラシアンが生成することもできます。',
  'rovo-chat.create-agent.conversation-starters-field-label': '会話のきっかけ',
  'rovo-chat.create-agent.create-agent-button': '作成',
  'rovo-chat.create-agent.ctions-section-title': 'アクション',
  'rovo-chat.create-agent.description-field-description':
    'ユーザーがエージェントのプロファイルの説明を見て詳細を把握できます。',
  'rovo-chat.create-agent.description-field-label': '説明',
  'rovo-chat.create-agent.description-field-placeholder':
    'エージェントについての簡単な説明を入力 (「マーケティング ブログのクリエイティブ ライター」など)',
  'rovo-chat.create-agent.instructions-field-description':
    'エージェントの動作や機能について指示します。<link>エージェントへの指示の書き方をご確認ください。</link>',
  'rovo-chat.create-agent.instructions-field-label': '説明',
  'rovo-chat.create-agent.instructions-field-placeholder': 'このエージェントへの指示をカスタマイズします',
  'rovo-chat.create-agent.intro-description-part-1':
    '専門知識を持ったエージェントを作成し、業務の効率化に役立てましょう。エージェントは質問に答えたり、コンテンツの文章を記述・レビューしたり、特定のタスクを実行したりできます。',
  'rovo-chat.create-agent.intro-description-part-2':
    'ヘルプが不要な場合は、<bold>スキップして手動セットアップに進むことができます。</bold>',
  'rovo-chat.create-agent.intro-description-part-3':
    'ヘルプが必要な場合はこのページをご活用ください。アトラシアンが作成をお手伝いします。',
  'rovo-chat.create-agent.intro-step-1-content':
    'あなたが記述した内容に基づいて、エージェントへの指示を作成します。エージェントを何に使用するつもりなのかを教えてください。',
  'rovo-chat.create-agent.intro-step-1-title': 'エージェントに何をしてほしいかを説明する',
  'rovo-chat.create-agent.intro-step-2-content':
    'エージェントの名前と性格を決めましょう。エージェントは親しみやすい性格か、率直な性格か、愉快な性格かを教えてください。',
  'rovo-chat.create-agent.intro-step-2-title': '個性を加える',
  'rovo-chat.create-agent.intro-step-3-content':
    '[<bold>次へ</bold>] をクリックして、新しいエージェントを確認し、アクション、ナレッジ、プロファイル写真を追加します。すべて完了したら、[<bold>作成</bold>] を選択します。',
  'rovo-chat.create-agent.intro-step-3-title': 'エージェントを確認して作成する',
  'rovo-chat.create-agent.intro-title': '👋 エージェントを作成しましょう',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'すべてのプロジェクト',
  'rovo-chat.create-agent.knowledge-field-description':
    '以下で指定する情報源のみを参照するように設定して、エージェントのナレッジを限定できます',
  'rovo-chat.create-agent.knowledge-field-label': 'ナレッジ',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': '以下の情報源のみを参照する',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': '候補',
  'rovo-chat.create-agent.manage-actions-button-label': 'アクションを管理',
  'rovo-chat.create-agent.name-field-description': 'ユーザーがこの名前を使用してエージェントを検索できます。',
  'rovo-chat.create-agent.name-field-label': '名前',
  'rovo-chat.create-agent.name-field-placeholder': 'エージェントに名前を付ける',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    '予期しないエラーが発生しました。もう一度お試しください。',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'こんにちは。カスタム エージェントの作成をお手伝いします。エージェントに任せたいタスクについて教えてください。',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'メッセージを入力してください',
  'rovo-chat.create-agent.nl-input-field.send-button-label': '送信',
  'rovo-chat.create-agent.page-title': 'エージェントを作成する',
  'rovo-chat.create-agent.page-title-edit': 'エージェントを編集する',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'ページを検索',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'スペースを検索',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'すべて',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'ベータ版',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'キャンセル',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': '閉じる',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, other {選択するアクションを {count,number} 件未満に抑えると、パフォーマンスが最適化されます}}',
  'rovo-chat.create-agent.select-action-modal-save-button': '保存',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'アクションを検索',
  'rovo-chat.create-agent.select-action-modal-title': 'アクションを追加する',
  'rovo-chat.create-agent.select-content-under-label': '次の場所のコンテンツを選択',
  'rovo-chat.create-agent.select-spaces-label': 'スペースを選択',
  'rovo-chat.create-agent.selected-actions-label': '選択したアクション:',
  'rovo-chat.create-agent.unknown-owner': '不明',
  'rovo-chat.create-agent.update-agent-button': '更新',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    '続行すると、保存されていない変更は失われます。このエージェントの編集を続ける場合は、[キャンセル] を選択します。',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': '続行し、変更を破棄',
  'rovo-chat.edit-agent.confirm-discard-modal.title': '変更を破棄',
  'rovo-chat.view-agent.about-label': '概要',
  'rovo-chat.view-agent.actions-label': 'アクション',
  'rovo-chat.view-agent.beta-label': 'ベータ版',
  'rovo-chat.view-agent.beta-tag': 'ベータ版',
  'rovo-chat.view-agent.chat-to-agent-button': 'エージェントとチャット',
  'rovo-chat.view-agent.close-button': '閉じる',
  'rovo-chat.view-agent.copy-instructions-label': 'コピー',
  'rovo-chat.view-agent.copy-instructions-tooltip': '指示をコピー',
  'rovo-chat.view-agent.created-by-label': '<text>作成者</text>: {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'お気に入り数',
  'rovo-chat.view-agent.go-back-label': '戻る',
  'rovo-chat.view-agent.hidden-instructions-description':
    'コードで構築された Forge エージェントへの指示は、プライバシー保護のため非表示になっています。',
  'rovo-chat.view-agent.hidden-instructions-title': 'これらの説明は非公開です',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'コードで構築された Forge エージェントは一般的なナレッジ ソースを使用しません',
  'rovo-chat.view-agent.instructions-label': '説明',
  'rovo-chat.view-agent.knowledge-label': 'ナレッジ',
  'rovo-chat.view-agent.member-count': '{count, plural, other {{count,number} 人のメンバー}}',
  'rovo-chat.view-agent.modal-title': 'エージェントを参照する',
  'rovo-chat.view-agent.no-actions': 'アクションなし',
  'rovo-chat.view-agent.no-instruction-placeholder': 'このエージェントにカスタムの指示はありません',
  'rovo-chat.view-agent.no-knowledge-added': 'カスタム ナレッジ ソースはありません',
  'rovo-chat.view-agent.no-teams': 'どのチームにも属していません',
  'rovo-chat.view-agent.open-chat-label': 'チャットを開く',
  'rovo-chat.view-agent.reactions-metadata-label': 'リアクション数',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo エージェント',
  'rovo-chat.view-agent.teams-label': 'チーム',
  'rovo-chat.view-agent.users-metadata-label': 'ユーザー数',
};
